import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'horas-regalo/';

export interface PrecioPlanPermitidoInfo {
    id: number;
    plan_servicio: string;
    plan: string;
    servicio: string;
    precio_inicial: number;
    precio_posterior: number | null;
}

export interface HorasRegaloConfig {
    id: number;
    precio_plan_servicio_id: number;
    precio_plan_servicio_info: string;
    plan_config_info: string;
    servicio_asociado_nombre: string;
    horas_asignadas: number;
    precios_plan_permitidos: number[];  // Cambiado
    precios_plan_permitidos_info: PrecioPlanPermitidoInfo[];  // Nuevo
    activo: boolean;
    fecha_creacion: string;
}

export const fetchHorasRegaloConfigs = async (): Promise<HorasRegaloConfig[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const createHorasRegaloConfig = async (data: {
    precio_plan_servicio_id: number;
    horas_asignadas: number;
    precios_plan_permitidos: number[];  // Cambiado
    activo: boolean;
}): Promise<HorasRegaloConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

export const updateHorasRegaloConfig = async (
    id: number,
    data: {
        precio_plan_servicio_id: number;
        horas_asignadas: number;
        precios_plan_permitidos: number[];  // Cambiado
        activo: boolean;
    }
): Promise<HorasRegaloConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

export const deleteHorasRegaloConfig = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};
// Opcional: Función para obtener PrecioPlanServicio disponibles
export const fetchPrecioPlanServicioDisponibles = async (): Promise<any[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get('precio-plan-servicio/');
        return response.data;
    });
};